import * as React from 'react';
import { Accordion, useDeviceType } from '@cian/ui-kit';
import * as style from './styles.css';
import { clsx } from 'clsx';
import { FAQ } from './constants';
import { IAccordionItemClickEvent } from '@cian/ui-kit/accordion/types/accordionProps';
import { useApplicationContext } from '../../../common/utils/applicationContext';
import { clickBuyerFaqGarantItem } from '../../utils/tracking';

export const Faq: React.FC = () => {
  const device = useDeviceType();
  const { custom } = useApplicationContext();

  const handleItemClick = React.useCallback(
    ({ target, index }: IAccordionItemClickEvent) => {
      // Пользователь кликнул на  "Как работает гарантия безопасности сделки" в блоке "Вопросы и ответы"
      if (index === 0 && target.title === 'Как работает гарантия безопасности сделки?') {
        clickBuyerFaqGarantItem(custom);
      }
    },
    [custom],
  );

  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={clsx(style['title'], style[device])}>Вопросы и ответы</div>
      <Accordion onItemClick={handleItemClick} size={device === 'phone' ? 'S' : 'M'} items={FAQ} />
      <div className={style['related-link']}>
        Планируете продать квартиру?{' '}
        <a href="/sdelka/" className={style['link']}>
          Посмотрите, как Циан.Сделка помогает с продажей
        </a>
      </div>
    </div>
  );
};
